// Third-party
import React from 'react';
import moment from 'moment';

// Components
import DatesDisclaimer from './DatesDisclaimer';

// Utils
import { formatMessageWithLocale, FormattedMessage } from '../../../../utils/i18n';
import { getRollingDisclaimerDates } from '../../../../utils/disclaimers/comparison';
import { getLatestGraphedDate } from '../../../../utils/disclaimers/date-helpers/date-helpers';

// Types
import ComparisonItem from '@/types/comparison-item';
import RollingIntervals from '@/types/rolling-intervals';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  series: number[][];
  interval: RollingIntervals;
  endDate?: Date;
  shorthand?: boolean;
  showItemNames?: boolean;
  locale?: Locale;
}

const HypotheticalReturnDisclaimer = ({ items, series, interval, endDate, shorthand, showItemNames, locale }: Props) => {
  if (shorthand) {
    return (
      <span className="disclaimer dates-disclaimer">
        <FormattedMessage
          id={`Disclaimers.ShortHypotheticalReturns.${interval.toUpperCase()}`}
          values={{ date: getLatestGraphedDate(series, locale) }}
          locale={locale}
        />
      </span>
    );
  }

  return (
    <DatesDisclaimer
      globalPrefix={formatMessageWithLocale(`Disclaimers.HypotheticalReturns.${interval.toUpperCase()}`, locale)}
      itemPrefix={formatMessageWithLocale('Disclaimers.EndingOn', locale)}
      itemDates={getRollingDisclaimerDates(
        items.filter(item => item.holdings.length > 0),
        interval,
        endDate,
        locale,
      )}
      showItemNames={showItemNames}
      locale={locale}
    />
  );
};

export default HypotheticalReturnDisclaimer;
